// extracted by mini-css-extract-plugin
export default {"container":"WordGameLayout_container__0LPBh","sub_container":"WordGameLayout_sub_container__iS2+9"};